import { render, staticRenderFns } from "./LearnerHomePage.vue?vue&type=template&id=1a89b6aa"
import script from "./LearnerHomePage.vue?vue&type=script&lang=js"
export * from "./LearnerHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports